import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { Button } from '~/components/ui';
import { useAcceptCounterQuote } from '~/api';
import { toastGraphQLError } from '~/utils';
import type { NegotiableQuote } from './quoteNegotiation';

export function AcceptCounterQuoteAction({
  quote,
}: Readonly<{ quote: NegotiableQuote }>) {
  const { t } = useTranslation('rfq-view');
  const { mutateAsync: acceptCounterQuote, isPending } =
    useAcceptCounterQuote();
  const [isOpen, setIsOpen] = useState(false);

  const handleAccept = async () => {
    try {
      await acceptCounterQuote({ quoteId: quote.id });
      toast.success(t('rfq_view.counter_accepted'));
      setIsOpen(false);
    } catch (error) {
      toastGraphQLError(error);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <Button
        variant="primary"
        size="sm"
        width="auto"
        data-testid={`accept-counter-quote-${quote.id}`}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((current) => !current)}
      >
        {t('rfq_view.accept_counter_quote')}
      </Button>
      {isOpen && (
        <div className="flex flex-col gap-2 max-w-[260px]">
          <p className="text-xs text-neut-sec">
            {t('rfq_view.accept_counter_confirm_message')}
          </p>
          <Button
            variant="primary"
            size="sm"
            width="auto"
            data-testid={`confirm-accept-counter-${quote.id}`}
            onClick={() => void handleAccept()}
            disabled={isPending}
            loading={isPending}
          >
            {t('rfq_view.accept_counter_confirm')}
          </Button>
        </div>
      )}
    </div>
  );
}
